import Record from "./VideoRecorder";

export default Record;
